
/**
 * 改造工事費用算定機能を管理者として利用できるかどうかの判定
 *
 * @param {object} userInfo ログインユーザ情報
 * @param {object[]} gmNWDesignZgsyaCode 汎用マスタ(中電NW設計事業者コード)
 * @return {boolean} 管理者かどうかの判定結果
 */
export function isDrSideKoziCostAdmin(userInfo, gmNWDesignZgsyaCode) {
  const account = userInfo.Account;

  // 汎用マスタ「中電NW設計事業者コード」に、ログインユーザの共架事業者コードが存在するか確認
  const targetGm = gmNWDesignZgsyaCode.find(
      (item) => item.ValueString1__c === account.KyogaZgsyaCode__c);

  // 存在しない場合は管理者ではないと判断
  if (!targetGm) {
    return false;
  }

  // 「値_文字列2」のセミコロン区切りの2番目の値を取得（管理者判定用）
  const adminStr = targetGm.ValueString2__c?.split(';')?.[1];

  // 文字列が取得できなかった場合は管理者ではないと判断
  if (!adminStr) {
    return false;
  }

  // 文字列が「*」の場合、その共架事業者は全て管理者として判定
  if (adminStr === '*') {
    return true;
  }

  const permittedKyogaZgsyos = adminStr.split(',');

  // 共架事業所コードが許可されているか確認
  if (permittedKyogaZgsyos.includes(account.KyogaZgsyoCode__c)) {
    return true;
  }

  return false;
}

/**
 * 対象電柱一覧の中で設定されている工事グループ番号の最大値を取得する。
 * 最小値は1(電柱が1件も無い場合や、いずれの電柱にも工事グループが設定されていない場合でも、
 * 電柱情報入力で選択可能なグループ番号が1件は存在するようにする)。
 *
 * @param {Array} items 対象電柱一覧
 * @return {number} 工事グループ番号の最大値
 */
export function getMaxGroupNo(items) {
  return (items ?? []).reduce(
      (max, item) => Math.max(max, item.KoziGroup__c || 0), 1);
}
